import type { DirectoryPublic } from '@repo/types/directory';
import type { ComponentProps } from 'react';

import { cn } from '@repo/lib/cn';
import { MoreVertical } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { DropdownMenuTrigger } from '@/components/ui/dropdown-menu';
import { FolderIcon } from '@/components/ui/file-icon';
import { FileCard, FileCardContent, FileCardTitle } from '@/components/ui/fs-card';

/**
 * Props for the FsDirectoryCard component.
 * @property {DirectoryPublic} directory - The directory data to display.
 * @property {boolean} [disabledMenu] - Whether to disable the menu trigger.
 * @property {...ComponentProps<typeof FileCard>} [props] - Additional props for the FileCard.
 */
interface FsDirectoryCardProps extends ComponentProps<typeof FileCard> {
  directory: DirectoryPublic;
  disabledMenu?: boolean;
}

export default function FsDirectoryCard(fsDirectoryCardProps: FsDirectoryCardProps) {
  const { directory, className, disabledMenu = false, ...props } = fsDirectoryCardProps;
  return (
    <FileCard key={directory.id} className={cn(className, 'cursor-pointer')} {...props}>
      <FileCardContent>
        <FolderIcon />
        <FileCardTitle>{directory.name}</FileCardTitle>
        <DropdownMenuTrigger disabled={disabledMenu} asChild>
          <Button variant={'ghost'} size={'sm'}>
            <MoreVertical />
          </Button>
        </DropdownMenuTrigger>
      </FileCardContent>
    </FileCard>
  );
}
